var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('download-excel',{staticClass:"export-excel-wrapper",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"name":_vm.name_title+'.xls'}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("导出")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0beaa9c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/json_data.vue
// module id = null
// module chunks = 